import { css, cx } from 'emotion';
import { helvetica } from 'inside-out/global-styles';

export const wrapperStyle = bgColor => css({
  height: '56px',
  width: '100%',
  position: 'sticky',
  top: '0',
  backgroundColor: bgColor,
  zIndex: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '10px',
});

export const contentStyle = color => css({
  '&, & *': {
    color: `${color} !important`,
    ...helvetica,
    fontSize: '16px',
    lineHeight: '17px',
  },
  '& a': {
    fontWeight: '700',
  },
});

const iconStyle = css({
  width: '24px',
  height: '24px',
  backgroundSize: 'content',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
})

export const bellIconStyle = cx(
  iconStyle,
  css({
    marginRight: '8px',
    backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIyMSI+PHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0zLjEzMyAxMy4wOTRWNy4yNUMzLjEzMyA1LjEyNSA1LjggMyA5IDNzNS44NjcgMi4xMjUgNS44NjcgNC4yNXY1Ljg0NGMxLjQyMiAwIDIuMTMzLjcwOCAyLjEzMyAyLjEyNXMtLjcxMSAyLjEyNS0yLjEzMyAyLjEyNUgzLjEzM0MxLjcxMSAxNy4zNDQgMSAxNi42MzUgMSAxNS4yMTlzLjcxMS0yLjEyNSAyLjEzMy0yLjEyNXptMy43MzQgNC4yNWg0LjI2NmMwIDEuNzctLjcxIDIuNjU2LTIuMTMzIDIuNjU2cy0yLjEzMy0uODg1LTIuMTMzLTIuNjU2ek03LjUgM2MwLTEuMzMzLjUtMiAxLjUtMnMxLjUuNjY3IDEuNSAyaC0zeiIvPjwvc3ZnPg==")',
  }),
);

export const closeIconStyle = cx(
  iconStyle,
  css({
    position: 'absolute',
    right: '16px',
    top: '50%',
    transform: 'translateY(-50%)',
    mixBlendMode: 'difference',
    cursor: 'pointer',
    backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjE4IiB3aWR0aD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTguOTg1IDcuNTcxbDYuMzY0LTYuMzY0YTEgMSAwIDAgMSAxLjQxNCAxLjQxNEwxMC40IDguOTg1bDYuMzY0IDYuMzY0YTEgMSAwIDAgMS0xLjQxNCAxLjQxNEw4Ljk4NSAxMC40bC02LjM2NCA2LjM2NGExIDEgMCAxIDEtMS40MTQtMS40MTRsNi4zNjQtNi4zNjQtNi4zNjQtNi4zNjRhMSAxIDAgMCAxIDEuNDE0LTEuNDE0eiIgZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+")',
  }),
);


// WEBPACK FOOTER //
// ./src/components/shared/topSticky/styles.js